export default ({ request }) => ({

  // 获取项目面料打样单明细记录
  getProjectInfoMaterialApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoMaterial/getProjectInfoMaterial',
      method: 'post',
      data
    })
  },
  // 更新项目打样单明细记录（根据主键更新）
  updateProjectInfoMaterialApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoMaterial/updateProjectInfoMaterial',
      method: 'post',
      data
    })
  },
  // 获取面料明细登记项名称列表（下拉填充）
  getMaterialItemNameListApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoMaterial/getMaterialItemNameList',
      method: 'post',
      data
    })
  },
  // 新增单条面料工艺记录
  addSingleMaterialItemApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoMaterial/addSingleMaterialItem',
      method: 'post',
      data
    })
  },
  // 删除单条面料工艺记录
  delSingleMaterialItemApi (data = {}) {
    return request({
      url: '/digitalCenter/project/infoMaterial/delSingleMaterialItem',
      method: 'post',
      data
    })
  }
})